import { authorizeGetRequest, authorizePostRequest } from "api";
import {
  IDriverLocationResponse,
  ILocation,
  ITripRequestDriverLocation,
  IDispatchTripInput,
} from "models/dispatch";

export const findOnlineDriversLocationApi = ({ lat, lng, exclude_stuck }: ILocation & { exclude_stuck?: boolean }) => {
  const params = new URLSearchParams({
    latitude: lat.toString(),
    longitude: lng.toString(),
  });

  if (exclude_stuck !== undefined) {
    params.append('exclude_stuck', exclude_stuck.toString());
  }

  return authorizeGetRequest<IDriverLocationResponse>(
    `drivers/location?${params.toString()}`
  );
};

export const findTripRequestDriverLocationApi = (id: string) => {
  return authorizeGetRequest<ITripRequestDriverLocation>(
    `trip-requests/${id}/driver/location/admin`
  );
};

export const manualAssignApi = (data: IDispatchTripInput) => {
  return authorizePostRequest<any>(
    `dispatch/manual-assign`,
    data
  );
};
